import Experience from "./Experience/Experience"

const canvas = document.querySelector('canvas.webgl')
const experience = new Experience(canvas)